"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconCopy = Experimental__IconCopy;
exports.IconCopy = IconCopy;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * @deprecated IconCopy is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function IconCopy(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'m8.235 3.569 1.11-1.11a3.012 3.012 0 1 1 4.261 4.26L11.464 8.86a3.012 3.012 0 0 1-4.907-.96 1.49 1.49 0 0 0-.952.436l-.351.351a4.524 4.524 0 0 0 7.279 1.242l2.142-2.143A4.524 4.524 0 1 0 8.277 1.39L6.292 3.373a6.063 6.063 0 0 1 1.943.195z\'/><path d=\'m7.765 12.56-1.11 1.11a3.013 3.013 0 0 1-4.261-4.26l2.142-2.142a3.012 3.012 0 0 1 4.907.96 1.49 1.49 0 0 0 .952-.436l.351-.351a4.524 4.524 0 0 0-7.279-1.242L1.325 8.342a4.524 4.524 0 1 0 6.398 6.397l1.985-1.984a6.064 6.064 0 0 1-1.943-.195z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'m13.78 4.582-1.469 1.47a8.022 8.022 0 0 0-2.57-.258l2.626-2.626a5.986 5.986 0 0 1 8.465 8.465l-2.835 2.835a5.986 5.986 0 0 1-9.63-1.643l.464-.465c.351-.35.8-.543 1.26-.576a3.986 3.986 0 0 0 6.492 1.27l2.835-2.835a3.986 3.986 0 1 0-5.637-5.637z\'/><path d=\'m10.22 19.418 1.469-1.47c.84.225 1.708.311 2.57.258l-2.626 2.626a5.986 5.986 0 1 1-8.465-8.466l2.835-2.834a5.986 5.986 0 0 1 9.63 1.643l-.464.464a1.97 1.97 0 0 1-1.26.577 3.986 3.986 0 0 0-6.492-1.27l-2.835 2.835a3.986 3.986 0 1 0 5.637 5.637z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated IconCopy is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function Experimental__IconCopy(props) {
  return /*#__PURE__*/_react["default"].createElement(IconCopy, props);
}